var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { ThemeProvider } from "@mui/material/styles";
import theme from '../theme';
import { pxToRem } from "../conversion";
import MenuIcon from "@mui/icons-material/Menu";
import { Avatar, SwipeableDrawer, useMediaQuery } from "@mui/material";
import { Box } from "@mui/material";
import { v1 } from "@variable/ui-icons";
var Topbar = function (props) {
    var _a, _b;
    var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    var _c = useState(false), drawerOpen = _c[0], setDrawerOpen = _c[1];
    return (_jsxs(ThemeProvider, __assign({ theme: theme }, { children: [_jsxs("div", __assign({ style: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    bottom: 0,
                } }, { children: [!isMobile && props.components.leftNavigation && props.components.leftNavigation(__assign({}, props.navProps)), isMobile && _jsx(SwipeableDrawer, __assign({ anchor: 'top', open: drawerOpen, onClose: function () { setDrawerOpen(false); }, variant: "temporary" }, { children: _jsx(Box, __assign({ sx: { width: isMobile ? "100%" : "300px" } }, { children: props.components.leftNavigation && props.components.leftNavigation(__assign(__assign({}, props.navProps), { drawerOpen: drawerOpen, setDrawerOpen: setDrawerOpen, editUser: __assign({}, props.user) })) })) }))] })), _jsxs("div", { children: [isMobile &&
                        _jsxs("div", __assign({ style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'var(--palette-black-1) 0% 0% no-repeat padding-box', padding: '0 10px' } }, { children: [_jsx(IconButton, __assign({ onClick: function () { return setDrawerOpen(!drawerOpen); } }, { children: _jsx(MenuIcon, { sx: { color: 'white' } }) })), _jsx(v1.Variable2, {}), _jsx(Box, __assign({ sx: {
                                        display: 'flex', alignItems: 'center', background: '#FFFFFF26 0% 0% no-repeat padding-box',
                                        borderRadius: '4px', padding: '15px 10px', margin: '10px'
                                    } }, { children: _jsx(Avatar, { src: ((_b = (_a = props.user) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.image) || "" }) }))] })), props.components.supplement && props.components.supplement(__assign({}, props)), !isMobile && _jsx(_Fragment, { children: _jsx(Tooltip, __assign({ title: "Help", sx: { marginLeft: '10px' } }, { children: _jsx(IconButton, __assign({ sx: {
                                    fontSize: pxToRem(24),
                                    '& svg': {
                                        fontSize: pxToRem(24)
                                    }
                                }, onClick: function (e) {
                                    if (props.events && props.events.onHelpClick) {
                                        props.events.onHelpClick(e.currentTarget);
                                    }
                                } }, { children: _jsx(HelpOutlineOutlinedIcon, { style: { fontSize: pxToRem(24) } }) })) })) })] })] })));
};
export default Topbar;
